import { createCustomEnum } from "./customEnum";

const PointTypes = createCustomEnum({
	None: {
		value: 0,
		name: "None",
		displayName: "None",
	},
	FirstData: {
		value: 1,
		name: "FirstData",
		displayName: "First Data",
	},
	TSYS: {
		value: 2,
		name: "TSYS",
		displayName: "TSYS",
	},
});

export default PointTypes;
